import { cn } from "@/lib/utils"

/**
 * Inline spinner shown inside a button while it is loading — replaces the label
 * entirely (no text), matching the Figma processing state and avoiding the iOS
 * WebKit glyph-ghosting that swapping button text mid-opacity-transition caused.
 * Tuned white for gradient pay buttons; override via `className`.
 */
export function ButtonSpinner({ className }: { className?: string }) {
  return (
    <span
      role="status"
      aria-label="Processing"
      className={cn(
        "size-6 animate-spin rounded-full border-2 border-white/90 border-t-transparent",
        className,
      )}
    />
  )
}
